module.exports = __webpack_public_path__ + "img/add-truck.977863dc.svg";